import React, { lazy } from 'react';
export function Testimonials() {
  const testimonials = [{
    src: 'https://cdn.magicpatterns.com/uploads/qn9kubc6w16YAvPTDeDMby/MARTIN_(1).webp',
    alt: 'Testimonio de Martin - Ya le hice una receta a mi perro, lo recomiendo totalmente'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/u3fb9m89r7pA3Ne1kUrWT7/CARLA_(1).webp',
    alt: 'Testimonio de Carla - No sabía que le estaba dando cosas que le hacían mal'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/kaL7bYQJhv3bmNi1NR2Rid/WhatsApp_Image_2026-04-29_at_14.42.34_(1).webp',
    alt: 'Testimonio de Lucia - El precio es barato por todo lo que ayuda y brinda'
  }];
  return <section className="py-10 px-4 bg-white" data-id="element-307">
      <div className="max-w-6xl mx-auto" data-id="element-308">
        <div className="text-center mb-6" data-id="element-309">
          <h2 className="text-3xl md:text-5xl font-black text-forest-green mb-3 font-serif" data-id="element-310">
            Mira Lo Que Dicen Los Dueños Que Ya Lo Vivieron:
          </h2>
          <div className="w-24 h-1.5 bg-gold mx-auto rounded-full" data-id="element-311"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-312">
          {testimonials.map((t, idx) => <div key={idx} className="rounded-2xl shadow-lg border-2 border-gold/20 overflow-hidden bg-cream" data-id="element-313">
              <img src={t.src} alt={t.alt} width={400} height={700} style={{
            contentVisibility: 'visible'
          }} className="w-full h-auto block" loading="lazy" decoding="async" data-id="element-314" />
            </div>)}
        </div>
      </div>
    </section>;
}